import { Organization } from '@/reservation/reservation.model';

export enum ERPCurrency {
	PLN = 'pln',
	EURO = 'eur',
	USD = 'USD',
	GBP = 'gbp',
}

export interface EventBusinessIssue {
	currency: ERPCurrency;
	date: string;
	documentNumber: string;
	documentType: string;
	due: string;
	eventBusiness: string;
	id: string;
	organization: Organization;
	paymentMethod: string;
	settled: string;
	value: string;
	valuePln?: string;
}

export interface EventBusinessCurrencyExchangeRateResult {
	data: number;
	error: Error;
	errorCode: number;
}
